import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import api from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { FileText } from "lucide-react";
import { toast } from "sonner";

function ContratoGuard() {
  const [info, setInfo] = useState(null);
  const [contrato, setContrato] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/contrato/estado").then(({ data }) => {
      if (data.requiere_aceptacion) {
        setInfo(data);
        api.get("/contrato").then(({ data: c }) => setContrato(c)).catch(() => {});
      }
    }).catch(() => {});
  }, []);

  const aceptar = async () => {
    setSaving(true);
    try { await api.post("/contrato/aceptar"); toast.success(`Contrato v${info.version_actual} aceptado`); setInfo(null); }
    catch { toast.error("No se pudo registrar la aceptación"); }
    finally { setSaving(false); }
  };

  if (!info) return null;
  return (
    <Dialog open onOpenChange={() => {}}>
      <DialogContent className="sm:max-w-2xl max-h-[92vh] flex flex-col" data-testid="contrato-guard-modal">
        <DialogHeader>
          <DialogTitle className="font-display flex items-center gap-2"><FileText className="h-5 w-5 text-[#F5A623]" /> Contrato de servicios · v{info.version_actual}</DialogTitle>
          <DialogDescription>Para continuar usando la plataforma, leé y aceptá la versión vigente del contrato.</DialogDescription>
        </DialogHeader>
        <div className="flex-1 min-h-0 overflow-y-auto rounded-lg border border-slate-200 p-4 space-y-4 text-sm" data-testid="contrato-guard-texto">
          {!contrato && <p className="text-[#64748B]">Cargando contrato…</p>}
          {contrato && (
            <>
              {contrato.intro.map((p, i) => <p key={i} className="text-[#64748B] leading-relaxed">{p}</p>)}
              {contrato.clausulas.map((cl) => (
                <div key={cl.n}>
                  <h4 className="font-semibold text-[#0A1F44]">{cl.n}. {cl.titulo}</h4>
                  {cl.parrafos.map((p, i) => <p key={i} className="text-[#64748B] mt-1 leading-relaxed">{p}</p>)}
                </div>
              ))}
            </>
          )}
        </div>
        <button onClick={aceptar} disabled={saving || !contrato} data-testid="contrato-aceptar-btn"
          className="w-full rounded-lg bg-emerald-500 hover:bg-emerald-600 text-white font-semibold py-2.5 text-sm disabled:opacity-60">
          {saving ? "Registrando..." : `He leído y acepto el contrato v${info.version_actual}`}
        </button>
      </DialogContent>
    </Dialog>
  );
}

export default function Layout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  return (
    <div className="min-h-screen bg-[#F4F5F7]">
      <Sidebar mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />
      <div className="lg:pl-64">
        <Outlet context={{ setMobileOpen }} />
      </div>
      <ContratoGuard />
    </div>
  );
}
